import React from "react";

import DataTable from "../../../DataTable";

import useOutputReportStore from "../../../../store/OutputReport.store";
import {
  extractRowKeys,
  formatDataTableColumns,
  getOutputType,
} from "../../../../utils/helpers/dataTable";
import { dataTableCopy } from "../../../../utils/resources/dataTableCopy";

const getFootnote = ({ reportType }) => {
  if (reportType === "cash") {
    return (
      <>
        {dataTableCopy.unlessOtherwiseStated}
        <br />
        [1]{dataTableCopy.targetPortfolios}
        <br />
        [2]{dataTableCopy.seeReferenceIndex}
      </>
    );
  }

  return (
    <>
      [1]{dataTableCopy.existingPortfolioInformation}
      <br />
      [2]{dataTableCopy.proposalNotMaintained}
      <br />
      [3]{dataTableCopy.seeReferenceIndex}
    </>
  );
};

const ESGRatingDataTable = () => {
  const reportName = "ESG Rating";
  const data = useOutputReportStore((state) => state.data);
  const types = useOutputReportStore((state) => state.types);
  const { reportType } = getOutputType(data);

  return (
    <DataTable
      reportType={reportType}
      variation="stylized"
      tableCaption={`${reportName} Data Table`}
      tableRowHeaderKey="ESG Rating"
      tableRowKeys={extractRowKeys(reportName, data)}
      tableColumns={formatDataTableColumns(reportName, data)}
      tableDataTypes={types?.[reportName]}
      formatCellDataBy="row"
      footnote={getFootnote({ reportType })}
      name="esgRating"
    />
  );
};

export default ESGRatingDataTable;
